import {
    homeResolve
} from '@/util'

const MapMinZoom = 3
const MapMaxZoom = 9
const MapCenter = [23.8, 124]
const MapMaxBounds = [[-20, 60], [70, 260]]

const MapStyle = {
    backgroundColor: '#ccc',
}

const GraticuleOptions = {
    showLabel: true,
    latLineCurved: 1,
    zoomInterval: [
        { start: 0, end: 1, interval: 50 },
        { start: 2, end: 3, interval: 20 },
        { start: 4, end: 5, interval: 10 },
        { start: 6, end: 7, interval: 5 },
        { start: 8, end: 20, interval: 1 }
    ]
}

const BaseGeoJsonLayerSettings = {
    style: {
        weight: 0.5,
        opacity: 1,
        fillOpacity: 1,
        color: '#333',
        fillColor: '#333'
    },
    layer_settings: {
        world_exasia_110: {
            src: '/' + process.env.ASSETS_SUB_DIR + '/data/world(exclude-asia)_110m.json',
            zoom: { start: 0, end: 24 }
        },
        asia_110: {
            src: '/' + process.env.ASSETS_SUB_DIR + '/data/asia_110m.json',
            zoom: { start: 0, end: 4 }
        },
        asia_extaiwan_50: {
            src: '/' + process.env.ASSETS_SUB_DIR + '/data/asia(exclude-taiwan)_50m.json',
            zoom: { start: 5, end: 24 }
        },
        taiwan_50: {
            src: '/' + process.env.ASSETS_SUB_DIR + '/data/taiwan_50m.json',
            zoom: { start: 5, end: 7 }
        },
        taiwan_10: {
            src: '/' + process.env.ASSETS_SUB_DIR + '/data/taiwan_10m.json',
            zoom: { start: 8, end: 24 }
        }
    }
}

const TerrainBaseLayerSettings = {
    url: 'http://stamen-tiles-{s}.a.ssl.fastly.net/terrain-background/{z}/{x}/{y}.{ext}',
    attribution: '',
    subdomains: 'abcd',
    ext: 'png'
}

const SatelliteBaseLayerSettings = {
    url: 'http://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
    attribution: ''
}

const SelectAreaOption = {
    shiftKey: false,
    validate: false,
    ctrlKey: false,
    autoDisable: true
}

const CycloneMarkerOptions = {
    icon_size: 32,
    color: {
        subject_fix: '#f7f7f7'
    }
}

const TrackIconCase = function(data) {
    let icon_size = this.icon_size
    let background_color = this.source_color
    let foreground_color = '#999999'
    let pathColor = 'RGBA(51,51,51,0.5)' // BG_COLOR
    let circleColor = this.source_color
    let icon_url = homeResolve(process.env.ASSETS_SUB_DIR, 'img', 'ty-nopower.svg')

    if (data.ws > 17.5) {
        icon_url = homeResolve(process.env.ASSETS_SUB_DIR, 'img', 'ty.svg')
        pathColor = this.source_color
        circleColor = 'RGBA(255,255,255,0)'
        if (data.ws > 32.6) {
            pathColor = this.source_color
            circleColor = this.source_color
        }
    } else if (data.ws > 0) {
        icon_url = homeResolve(process.env.ASSETS_SUB_DIR, 'img', 'td.svg')
    }

    var icon = L.svgIcon({
        iconUrl: icon_url,
        iconSize: [icon_size, icon_size],
        pathColor: pathColor,
        circleColor: circleColor,
        foregroundColor: foreground_color,
        backgroundColor: background_color
    })
    return icon
}

const FixIconCase = function(data) {
    let icon_size = this.icon_size
    let pathColor = 'RGBA(51,51,51,1)'
    let circleColor = 'RGBA(240,240,240,0.8)'
    let icon_url = homeResolve(process.env.ASSETS_SUB_DIR, 'img', 'td.svg')

    if (data.ws > 17.5) {
        icon_url = homeResolve(process.env.ASSETS_SUB_DIR, 'img', 'ty.svg')
        pathColor = 'RGBA(220,220,220,1)'
        circleColor = 'RGBA(255,255,255,0)'
        if (data.ws > 32.6) {
            pathColor = 'RGBA(220,220,220,1)'
            circleColor = 'RGBA(220,220,220,1)'
        }
    }

    let icon = L.svgIcon({
        iconUrl: icon_url,
        iconSize: [icon_size, icon_size],
        pathColor: pathColor,
        circleColor: circleColor
    })
    return icon
}

const CanvasFont = '"Microsoft JhengHei UI",' +
    '"Microsoft JhengHei",Pmingliu,' +
    '"Segoe UI",' +
    '"Segoe UI Web Regular",' +
    '"Segoe UI Symbol",' +
    '"Helvetica Neue",' +
    '"BBAlpha Sans",' +
    '"S60 Sans",Arial,sans-serif'

const LinkedTagDefaultStyle = {
    offset: [-64, 64],
    'color': '#777',
    'fillColor': 'rgba(255,255,255,0.7)',
    'border-color': '#fff',
    'border-radius': 4,
    'border-style': 'solid',
    'border-width': 1,
    'font-color': 'rgb(51,51,51)',
    'padding': '11px 11px 11px 7px',
    'font': '16px Verdana',
    'letterSpacing': null,
    lineOptions: {
        color: '#fff',
        weight: 1
    },
    icon: {
        src: homeResolve(process.env.ASSETS_SUB_DIR, 'img', 'ty-b.png'),
        size: [18, 18], // [w, h]
    }
}

const LinkedTagSrcStyle = {
    'fillColor': 'rgba(255,255,255,0.7)',
    'font': '14px' + CanvasFont,
    'border-color': '#fff',
    'border-radius': 0,
    'border-style': 'solid',
    'border-width': 1,
    'font-color': 'rgb(51,51,51)',
    'padding': '8px',
    offset: [-48, -48],
    lineOptions: {
        color: '#fff',
        weight: 1
    }
}

const TimeLabelOptions = {
    'border-width': 1,
    'border-radius': 4,
    'font': '16px' + CanvasFont,
    'padding': '14px 12px 10px 12px',
    'fillColor': 'rgb(51,51,51)',
    'border-color': '#fff',
    'border-style': 'solid',
    'font-color': '#fff',
    lineOptions: {
        color: '#fff',
        weight: 1.5
    }
};


const WindColorScale = [
    "rgb(255, 255, 255)",
    "rgb(170, 255, 170)",
    "rgb(170, 255, 85)",
    "rgb(255, 255, 0)", // 3
    "rgb(255, 224, 0)",
    "rgb(255, 193, 0)",
    "rgb(255, 159, 0)",
    "rgb(255, 127, 0)", // 7
    "rgb(255, 96, 0)",
    "rgb(255, 64, 0)",
    "rgb(255, 32, 0)",
    "rgb(255, 0, 0)", // 11
    "rgb(170, 0, 170)",
    "rgb(85, 0, 170)",
    "rgb(170, 85, 170)",
    "rgb(170, 170, 220)",
    "rgb(255, 255, 255)",
];
WindColorScale.indexFor = function(v) {
    if (v < 3.3) {
        return 0
    }
    if (v < 5.5) {
        return 1
    }
    if (v < 8.0) {
        return 2
    }
    if (v < 10.8) {
        return 3
    }
    // TD~
    if (v < 13.9) {
        return 4
    }
    if (v < 17.2) {
        return 5
    }
    // 輕度颱風~
    if (v < 20.8) {
        return 6
    }
    if (v < 24.5) {
        return 7
    }
    if (v < 28.5) {
        return 8
    }
    if (v < 32.7) {
        return 9
    }
    // 中度颱風~
    if (v < 37.0) {
        return 10
    }
    if (v < 41.5) {
        return 11
    }
    if (v <46.2) {
        return 12
    }
    if (v < 51.0) {
        return 13
    }
    // 強度颱風~
    if (v < 56.1) {
        return 14
    }
    if (v < 61.2) {
        return 15
    }
    // 超過17級風~
    return 16
};


const WindyOptions = {
    colorScale: WindColorScale,
    velocityScale: 0.007,
    particleAge: 180,
    particleMultiplier: (1.0/80),
    trailAge: 0.95,
    layer_worker_uri: "static/leaflet-windy/windy-layer-worker.js",
    opacity: 0.7,
    key_of_vector_u: 'u',
    key_of_vector_v: 'v',
    pane: 'shadowPane',
    lineWidth: 0.5,
    canvas_scale: 0.5
};

const TyProbColor = {
    0: 'transparent',
    20: '#7FED00',
    40: '#FFF400',
    60: '#FF8800',
    80: '#FF0000',
    100: '#9600FF'
};

const SatelliteOptions = {
    opacity: 0.9
}

export {
  MapStyle,
  MapMinZoom,
  MapMaxZoom,
  MapCenter,
  MapMaxBounds,
  GraticuleOptions,
  BaseGeoJsonLayerSettings,
  TerrainBaseLayerSettings,
  SatelliteBaseLayerSettings,
  CycloneMarkerOptions,
  SatelliteOptions,
  TrackIconCase,
  LinkedTagDefaultStyle,
  LinkedTagSrcStyle,
  TimeLabelOptions,
  FixIconCase,
  WindyOptions,
  TyProbColor,
}



// WEBPACK FOOTER //
// ./src/components/typhoon_tw/settings/index.js